window.profile = function($) {
    profile = {
        editModal: function() {
            var validationQueue = [];

            $('#modal-profile-edit, #modal-profile-delete').on('click', '[data-action]', function(e) {
                 // Pass through action value within the clicked element, used in the 'hide' handler
                $(e.delegateTarget).data('action', $(this).data('action'));
            }).on('hide.bs.modal', function (e) {
                var action = $(this).data('action');
                var errorMessageClass = 'error-message';
                var modal = this;
                var xhr = null;

                // Remove action for next usage
                $(this).removeData('action');

                // Remove previous errors
                $(this).find('.' + errorMessageClass).remove();

                // Bail early when modal is closed regularly (ESC press, overlay click, close-button etc.)
                if (action !== 'save') {
                    return;
                }

                // Force close
                if ($(this).data('force-close')) {
                    $(this).removeData('force-close');
                    return;
                }

                // Abort possible previous operations
                validationQueue.map(function(req, index) {
                    req.abort();
                    validationQueue.splice(index, 1);
                });

                // Prevent closing. Validate first.
                e.preventDefault();

                // Loading state
                $(this).addClass('modal--loading');

                // Save each form within modal with AJAX
                $(this).find('form.api-form').each(function () {
                    var keep = ['_form', '_token'];
                    var data = new FormData(this);
                    var api_route = $(this).data('api-route');
                    var action = $(this).data('action');

                    e.preventDefault();

                    if (!api_route) {
                        return;
                    }

                    var url = cfpluginvars.api_uri + api_route;

                    if (action != null) {
                        url = cfpluginvars.ajax_url;
                        data.append('action', action);
                        data.append('api_route', api_route)
                    }

                    data.append('blog_id', cfpluginvars.blog_id);

                    xhr = $.ajax({
                        type: 'POST',
                        dataType: 'json',
                        beforeSend: function (xhr) {
                            if (url != cfpluginvars.ajax_url) {
                                xhr.setRequestHeader('Authorization', 'Bearer ' + cfpluginvars.bearer_token);
                            }
                        },
                        url: url,
                        data: data,
                        processData: false,
                        contentType: false,
                    });

                    validationQueue.push(xhr);
                });

                // Wait until everything is validated
                $.when.apply($, validationQueue).then(function() {
                    // Close modal after successfull response
                    $(modal).data('force-close', true).modal('hide');

                    // Inject values in to page
                    profile.populateInput();

                    // Clear queue
                    validationQueue = [];
                }, function(xhr) {
                    var data = xhr.responseJSON;
                    var message = null;

                    if (! data) {
                        return;
                    }

                    switch (xhr.status) {
                        case 422 :
                            //message = 'Ongeldige invoer. Verbeter je fouten.'; // Inline error messages is sufficient
                            break;
                        case 500 :
                            message = 'Het aanpassen van je profiel is mislukt vanwege een technische fout. Probeer het opnieuw of neem contact met ons op.';
                            break;
                        default :
                            // Generic error messsage
                            message = data.message || 'Er heeft een technische fout plaatsgevonden';
                    }

                    // Show error next to fields
                    if (data.errors) {
                        profile.populateErrors(modal, data.errors);
                    }

                    if (data.data.errors) {
                        profile.populateErrors(modal, data.data.errors);
                    }

                    if (message) {
                        $(modal).find('.modal-body').append('<div class="' + errorMessageClass + ' text-danger">' + message + '</div>');
                    }

                    // Show modal again if user (quickly) closed it
                    if ($(modal).is(':hidden')) {
                        $(modal).modal('show');
                    }

                    console.log('some failed', arguments, this);
                }).always(function() {
                    $(modal).removeClass('modal--loading');
                });
            });
        },
        populateInput: function(context) {
            //@todo
            window.location.reload(); // Temporary solution to show data immidiatly
        },
        populateErrors: function(context, validationErrors) {
            var index = 0;

            for (var name in validationErrors) {

                var inputName = name.replace(/\.(.+?)(?=\.|$)/g, function(m, s) {
                    return '[' + s + ']';
                });

                var $input = $(context).find('[name="' + inputName + '"]');
                var $errorList = $('<ul />');
                var errors = validationErrors[name];

                // Change insert position when [type=file] because cusomt styled upload button
                if ($input.is('[type="file"]')) {
                    $input = $input.closest('div');
                }

                // Add support for array indexed inputs (defined with [] brackets)
                if ($input.length === 0) {
                    $input = $('[name="' + inputName.replace(index, '') + '"]').eq(index);
                }

                // Add support for big collections (eg. features[] checkboxes)
                if ($input.length === 0) {
                    $input = $('[name="' + inputName.replace(index, '') + '[]"]').closest('.form-group').children().last();
                }

                // User input not found...
                if ($input.length === 0) {
                    console.warn(name, inputName, 'not found');
                }

                $.each(errors, function(i, error) {
                    $('<li />').text(error).appendTo($errorList);
                });

                $('<div class="error-message alert alert-danger" />').append($errorList).insertAfter($input);

                index++;
            }

            this.scrollToFirstError(context);
        },
        scrollToFirstError: function(context) {
            var $container = $(context).find('.modal-body');
            var $firstError = $container.find('.error-message').first();
            var visibilityOffset = -15; // Appearance tweak
            var offset = 0;

            if ($firstError.length === 1) {
                $firstError = $firstError.closest('.form-group'); // Focus on <label> by using .form-group as reference
            }

            if ($firstError.length === 1) {
                offset = $firstError.offset().top - $container.offset().top + $container.scrollTop() + visibilityOffset;
            }

            $container.animate({scrollTop: offset });
        }
    };

    return profile;
}(jQuery);
